
<template>
        <v-container>
          <template>
            <v-stepper v-model="createSchool" class="card-r no-shadow">
              <v-btn icon class="right" to="/">
                <v-icon class="textColor " >close</v-icon>
              </v-btn>
              <p class="text-xs-center textColor f-20 mt-4 ml-5 font-weight-bold">Admin panel usage</p>
              <v-stepper-header class="mr-4 ml-4 card-r no-shadow grey lighten-3 hidden-xs-only hidden-sm-only hidden-md-only">
                <v-stepper-step :complete="createSchool > 1" step="1">Create Classes</v-stepper-step>
                <v-stepper-step :complete="createSchool > 2" step="2">Create Packages</v-stepper-step>
                <v-stepper-step :complete="createSchool > 3" step="3">Create Teachers</v-stepper-step>
                <v-stepper-step :complete="createSchool > 4" step="4">Create Students</v-stepper-step>
              </v-stepper-header>
              <v-stepper-items>
                <v-stepper-content step="1" class="pb-5">
                  <div class="text-xs-center f-15">Step 1 of 5</div>
                  <v-card class="card-r no-shadow ">
                    <v-form>
                      <v-card-text class="pa-0">
                        <v-container grid-list-md>
                          <v-layout wrap >
                            <v-flex xs12><v-text-field label="Class Title"></v-text-field>
                            </v-flex>
                            <v-flex xs12 offset-xs0 class="pa-1 " >
                              <v-select
                                :items="vehicle"
                                class="input-group--focused"
                                label="vehicle Type"
                              ></v-select>
                            </v-flex>
                            <v-flex xs12 ><v-text-field label="Class Location"></v-text-field></v-flex>
                            <v-flex xs12 offset-xs0 class="pa-1 " >
                              <v-select
                                :items="workMin"
                                class="input-group--focused"
                                label="Hours"
                              ></v-select>
                            </v-flex>
                            <v-flex xs12 >
                              <v-text-field label="Class Price"></v-text-field></v-flex>
                            <v-flex xs12 >
                              <v-text-field label="Internal Price"></v-text-field></v-flex>
                            <v-flex xs12 >
                              <v-textarea name="input-7-1" label="Description"></v-textarea></v-flex>
                            <v-layout wrap lg12>
                              <v-flex md12 sm12 xs12 lg12 class="">
                                <v-card class="text-xs-left card-r no-shadow mb-2">
                                  <v-flex xs12 class="">
                                    <input
                                      type="file"
                                      ref="ImgInput"
                                      style="display: none"
                                      accept="image/*"
                                      @change="onImgPicked">
                                    <v-btn
                                      small
                                      class="card-r"
                                      outline
                                      @click="onPickImg">Upload Gallery</v-btn>
                                  </v-flex>
                                  <v-flex xs12 style="display:flex; overflow-x: scroll;">
                                    <v-flex class="ma-2" v-for="n in attachment.photosURL" :key="n" xs12>
                                      <v-card flat tile flex>
                                        <v-img
                                          :src="n"
                                          style="height: 100px; width: 100px !important;"
                                          :lazy-src="n"
                                          aspect-ratio="1"
                                          class="grey lighten-2">
                                          <v-layout
                                            slot="placeholder"
                                            fill-height
                                            align-center
                                            justify-center
                                            ma-0>
                                            <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                                          </v-layout>
                                        </v-img>
                                      </v-card>
                                    </v-flex>
                                  </v-flex>
                                </v-card>
                              </v-flex>
                            </v-layout>
                          </v-layout>
                        </v-container>
                      </v-card-text>
                    </v-form>
                  </v-card>
                  <v-btn color="primary right card-r no-shadow mb-5"  @click="createSchool = 2 ">Next</v-btn>
                </v-stepper-content>

                <v-stepper-content step="2" class="pb-5">
                  <div class="text-xs-center f-15">Step 2 of 5</div>
                  <v-card class="card-r no-shadow">
                    <v-card-text class="pa-0">
                      <v-container grid-list-md>
                        <v-layout wrap >
                          <v-flex xs12><v-text-field label="Package Title"></v-text-field>
                          </v-flex><v-flex xs12 ><v-text-field label="Package Location"></v-text-field></v-flex>
                          <v-flex xs12 >
                            <v-text-field label="Package Price"></v-text-field></v-flex>
                          <v-flex xs12 >
                            <v-text-field label="Internal Price"></v-text-field></v-flex>
                          <v-flex xs12 >
                            <v-textarea name="input-7-1" label="Description"></v-textarea></v-flex>
                          <v-flex xs12>
                            <v-combobox :items="items" label="Select Classes" multiple chips>
                              <template slot="selection" slot-scope="data">
                                <v-chip
                                  :selected="data.selected"
                                  :disabled="data.disabled"
                                  :key="JSON.stringify(data.item)"
                                  class="v-chip--select-multi"
                                  @input="data.parent.selectItem(data.item)">
                                  <v-avatar
                                    class="accent white--text"
                                    v-text="data.item.slice(0, 1).toUpperCase()"></v-avatar>{{ data.item }}</v-chip>
                              </template>
                            </v-combobox>
                          </v-flex>
                        </v-layout>
                      </v-container>
                    </v-card-text>
                  </v-card>
                  <v-btn color="primary right card-r no-shadow mb-5"  @click="createSchool = 3 ">Next</v-btn>
                  <v-btn color="right card-r no-shadow mb-5"  @click="createSchool =  1 ">back</v-btn>
                </v-stepper-content>

                <v-stepper-content step="3" class="pb-5">
                  <div class="text-xs-center f-15">Step 3 of 5</div>
                  <v-layout wrap>
                    <v-flex md12 sm12 xs12 lg12 class="text-xs-left ">
                      <span class="f-15 textColor font-weight-bold">Personal info</span>
                      <v-flex xs12>
                        <v-text-field
                          required
                          color="#749DBF"
                          type="text"
                          placeholder="User Name"
                          class="textFeald"
                          solo
                          label="Full Name"
                          v-model="fullName"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12>
                        <v-text-field
                          required
                          color="#749DBF"
                          class="textFeald"
                          solo
                          label="Phone Number"
                          placeholder="Phone Number"
                          :rules="[ v => v.length >= 8 || 'Min 8 characters']"
                          v-model="PhoneNumber"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12  class="w-100 mb-2">
                        <div class="ma-0 white w-100">
                          <date-dropdown min="1960" max="2019" v-model="selectedDate" />
                        </div>
                      </v-flex>
                      <v-flex xs12>
                        <vue-dawa
                          @select="selectItem(ascwesdavc , address)"
                          :val="adminaddressoneLineAddress"
                          :showMax="5"
                          containerId="amdinAddress_container"
                          fieldId="amdinAddress_id"
                          fieldName="amdinAddress_name"
                        >
                          <label slot="label-top" class="active">Address</label>
                        </vue-dawa>
                      </v-flex>
                      <v-flex xs12>
                        <v-select
                          :items="gender"
                          class="input-group--focused"
                          label="Gender"
                        ></v-select>
                      </v-flex>
                      <v-flex xs12>
                        <v-text-field
                          required
                          color="#749DBF"
                          class="textFeald"
                          solo
                          label="Club name"
                          placeholder="Club name"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12>
                        <v-text-field
                          name="Email"
                          label="Email"
                          hint="email is required"
                          v-model="wecvewrgc"
                          class="input-group--focused"
                          required
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12>
                        <v-text-field
                          required
                          color="#749DBF"
                          class="textFeald"
                          type="password"
                          solo
                          label="Password"
                          :rules="passwordRule"
                          placeholder="Password"
                          v-model="password"
                        ></v-text-field>
                      </v-flex>
                    </v-flex>
                  </v-layout>
                  <v-card class="white card-r no-shadow">
                    <v-card-text class="pa-0">
                      <v-layout wrap>
                        <div class="f-15 textColor font-weight-bold">Customize Teacher Schedule</div>
                        <v-flex xs12 class="text-xs-left">

                          <v-tabs class="text-xs-center white" slot="extension" v-model="tab" >
                            <v-tabs-slider color="unset"></v-tabs-slider>

                            <v-tab to="#tab-1" class=" white">
                              <v-avatar color="primary" size="40px">
                                <span class="f-12 font-weight-regular white--text">M</span>
                              </v-avatar>
                            </v-tab>

                            <v-tab to="#tab-2" class=" white">
                              <v-avatar color="primary" size="40px">
                                <span class="f-12 font-weight-regular white--text">T</span>
                              </v-avatar>
                            </v-tab>

                            <v-tab to="#tab-3" class=" white">
                              <v-avatar color="primary" size="40px">
                                <span class="f-12 font-weight-regular white--text">W</span>
                              </v-avatar>
                            </v-tab>
                            <v-tab to="#tab-4" class=" white">
                              <v-avatar color="primary" size="40px">
                                <span class="f-12 font-weight-regular white--text">T</span>
                              </v-avatar>
                            </v-tab>

                            <v-tab to="#tab-5" class=" white">
                              <v-avatar color="primary" size="40px">
                                <span class="f-12 font-weight-regular white--text">F</span>
                              </v-avatar>
                            </v-tab>

                            <v-tab to="#tab-6" class=" white">
                              <v-avatar color="primary" size="40px">
                                <span class="f-12 font-weight-regular white--text">S</span>
                              </v-avatar>
                            </v-tab>
                            <v-tab to="#tab-7" class=" white">
                              <v-avatar color="primary" size="40px">
                                <span class="f-12 font-weight-regular white--text">S</span>
                              </v-avatar>
                            </v-tab>
                          </v-tabs>
                          <v-tabs-items v-model="tab" class="transparent">
                            <v-tab-item  v-for="i in 7" :value="'tab-' + i" :key="i">
                              <v-card flat class=" white">
                                <v-flex xs12 class="checkbox pa-0">

                                  <v-checkbox
                                    label="same as previous schedule"
                                    required
                                  ></v-checkbox>
                                </v-flex>
                                <span class="f-15 textColor font-weight-bold">Add Your Class Schedule</span>
                                <div class="list-dbg">
                                  <v-layout xs12 class="">

                                    <v-flex xs4 offset-xs0 class="text-xs-center pa-1">
                                      <span class="f-12 font-weight-bold text-primary">Start</span>
                                      <div class="containerr y proximity-scroll-snapping " dir="ltr">
                                        <div v-for="i in 24" :key="i.id" @change="hour(i)">{{i}}</div>
                                      </div>
                                    </v-flex>
                                    <v-flex xs4 offset-xs0 class="text-xs-center pa-1">
                                      <span class="f-12 font-weight-bold text-primary">Min</span>
                                      <div class="containerr y proximity-scroll-snapping " dir="ltr">
                                        <div class="">15</div>
                                        <div>30</div>
                                        <div>45</div>
                                        <div>00</div>
                                      </div>
                                    </v-flex>
                                    <v-flex xs4 offset-xs0 class="text-xs-center pa-1">
                                      <span class="f-12 font-weight-bold text-primary">Work Min</span>
                                      <div class="containerr y proximity-scroll-snapping " dir="ltr">
                                        <div class=" ">45 </div>
                                        <div class="">90 </div>
                                        <div class="">135 </div>
                                        <div class="">135 </div>
                                        <div class="">180 </div>
                                        <div class="">225 </div>
                                      </div>
                                    </v-flex>
                                    <!--<v-flex xs1 class=" text-xs-center ">-->
                                    <v-avatar :size="25" class="pointer" color="primary"  v-on:click="counter -= 1">
                                      <v-icon dark class="f-8 white--text">close</v-icon>
                                    </v-avatar>
                                    <!--</v-flex>-->
                                  </v-layout>
                                </div>
                                <div class="list-dbg mt-2 mb-2" v-for="n in counter" :key="n">
                                  <v-layout xs12 class="">

                                    <v-flex xs4 offset-xs0 class="text-xs-center pa-1">
                                      <span class="f-12 font-weight-bold text-primary">Start</span>
                                      <div class="containerr y proximity-scroll-snapping " dir="ltr">
                                        <div v-for="i in 24" :key="i.id" @change="hour(i)">{{i}}</div>
                                      </div>
                                    </v-flex>
                                    <v-flex xs4 offset-xs0 class="text-xs-center pa-1">
                                      <span class="f-12 font-weight-bold text-primary">Min</span>
                                      <div class="containerr y proximity-scroll-snapping " dir="ltr">
                                        <div class="">15</div>
                                        <div>30</div>
                                        <div>45</div>
                                        <div>00</div>
                                      </div>
                                    </v-flex>
                                    <v-flex xs4 offset-xs0 class="text-xs-center pa-1">
                                      <span class="f-12 font-weight-bold text-primary">Work Min</span>
                                      <div class="containerr y proximity-scroll-snapping " dir="ltr">
                                        <div class=" ">45 </div>
                                        <div class="">90 </div>
                                        <div class="">135 </div>
                                        <div class="">135 </div>
                                        <div class="">180 </div>
                                        <div class="">225 </div>
                                      </div>
                                    </v-flex>
                                    <v-avatar :size="25" color="primary" class="pointer"  v-on:click="counter -= 1">
                                      <v-icon dark class="pointer f-8 white--text">close</v-icon>
                                    </v-avatar>
                                  </v-layout>
                                </div>
                                <span class="f-15 textColor font-weight-bold">Add More Schedule</span>

                                <v-layout >
                                  <v-flex xs2 class="pa-2 pt-2 pb-3">
                                    <v-avatar :size="40" color="primary" class="cell" v-on:click="counter += 1">
                                      <v-icon dark class="f-12 font-weight-regular white--text">add</v-icon>
                                    </v-avatar>
                                    <br>

                                  </v-flex>
                                </v-layout>

                              </v-card>
                            </v-tab-item>
                          </v-tabs-items>
                        </v-flex>
                      </v-layout>
                    </v-card-text>
                  </v-card>
                  <v-btn color="primary right card-r no-shadow mb-5"  @click="createSchool = 4 ">Next</v-btn>
                  <v-btn @click="createSchool =  2 " class="right card-r no-shadow">Back</v-btn>
                </v-stepper-content>

                <v-stepper-content step="4" class="pb-5">
                  <div class="text-xs-center f-15">Step 3 of 5</div>
                  <v-card class="card-r no-shadow">
                    <v-card-text class="pa-0">
                      <v-container grid-list-md>
                        <v-layout wrap>
                          <span class="f-15 textColor font-weight-bold">Personal info</span>
                          <v-flex xs12>
                            <v-text-field
                              required
                              color="#749DBF"
                              type="text"
                              placeholder="User Name"
                              class="textFeald"
                              solo
                              label="Full Name"
                              v-model="fullName"
                            ></v-text-field>
                          </v-flex>
                          <v-flex xs12>
                            <v-text-field
                              required
                              color="#749DBF"
                              class="textFeald"
                              prefix="+47"
                              solo
                              label="Phone Number"
                              placeholder="Phone Number"
                              :rules="[ v => v.length >= 8 || 'Min 8 characters']"
                              v-model="PhoneNumber"
                            ></v-text-field>
                          </v-flex>
                          <span class="f-8 textColor f-10 white w-100 text-xs-left font-weight-bold">Date Of Birth</span>

                          <v-flex xs12  class="w-100 mb-2">
                            <div class="ma-0 white w-100">
                              <date-dropdown min="1960" max="2019" v-model="selectedDate" />
                            </div>
                          </v-flex>

                          <v-flex xs12>
                            <vue-dawa
                              @select="selectItem(ascwesdavc , address)"
                              :val="adminaddressoneLineAddress"
                              :showMax="5"
                              containerId="amdinAddress_container"
                              fieldId="amdinAddress_id"
                              fieldName="amdinAddress_name"
                            >
                              <label slot="label-top" class="active">Address</label>
                            </vue-dawa>
                          </v-flex>
                          <v-flex xs12>
                            <v-select
                              :items="gender"
                              class="input-group--focused"
                              label="Gender"
                            ></v-select>
                          </v-flex>
                          <v-flex xs12>
                            <v-text-field
                              required
                              color="#749DBF"
                              class="textFeald"
                              solo
                              label="Club name"
                              placeholder="Club name"
                            ></v-text-field>
                          </v-flex>
                          <v-flex xs12>
                            <v-text-field
                              name="Email"
                              label="Email"
                              hint="email is required"
                              v-model="wecvewrgc"
                              class="input-group--focused"
                              required
                            ></v-text-field>
                          </v-flex>
                          <v-flex xs12>
                            <v-text-field
                              required
                              color="#749DBF"
                              class="textFeald"
                              type="password"
                              solo
                              label="Password"
                              :rules="passwordRule"
                              placeholder="Password"
                              v-model="password"
                            ></v-text-field>
                          </v-flex>
                          <span class="f-15 textColor font-weight-bold">Select Package</span>
                          <v-flex md12 sm12 xs12 class="">
                            <v-select
                              :items="package"
                              class="input-group--focused"
                              label="Select Package"
                            ></v-select>
                          </v-flex>
                          <span class="f-15 textColor font-weight-bold">Select Teacher</span>
                          <v-flex md12 sm12 xs12 class="">
                            <v-select
                              :items="Teachers"
                              class="input-group--focused"
                              label="Select Teacher"
                            ></v-select>
                          </v-flex>
                        </v-layout>
                      </v-container>
                    </v-card-text>
                  </v-card>
                  <v-btn color="primary right card-r no-shadow mb-5 text-white" to="/">Next</v-btn>
                  <v-btn @click="createSchool =  3 " class="right card-r no-shadow">Back</v-btn>
                </v-stepper-content>

              </v-stepper-items>
            </v-stepper>
          </template>
        </v-container>
</template>

<script>
  /* eslint-disable */
  import DateDropdown from 'vue-date-dropdown'
  import VueDawa from "vue-dawa";

  export default {
    data: () => ({
      seen: true,
      createSchool: 0,
      dialog: false,
      attachment: {
        photos: [],
        photosURL: [],
        videos: [],
        videosURL: []
      },
      vehicle : ["Car" , "Bike" ,"Car & Bike"],
      tab :null,
      counter: 0,
      show: true,
      date : null,
      birthday: false,
      type: ["Student", "Teacher"],
      gender: ["male", "female" ,"non binary"],
      package: ["package 1 ($5400) (12classes)", "package 2 ($3600) (8classes)" , "package 3 ($1800) (4classes)"],
      Teachers: ["Teacher name 1", "Teacher name 2" , "Teacher name 3"],
      timeslot: ["07:00 am", "08:00 am" , "09:00 am", "10:00 am" ,"11:00 am", "12:00 pm", "01:00 pm", "02:00 pm", "03:00 pm", "04:00 pm", "05:00 pm", "06:00 pm"],
      breakmin: ["15 min", "30 min" , "45 min", "60 min" ],
      gender_: ["male", "female" ,"non binary"],
      time: null,
      menu2: false,
      workMin : ["60 min", "120 min" , "180 min", "240 min" ,"300 min", "360 min", "420 min", "480 min" ],

    }),
    watch: {},
    created() {},
    methods: {
      selectItem(payload, objectName) {
        this.$set(this, objectName, this.translateData(payload));
        console.log(this.address);
      },
      translateData(address) {
        if (!address || !address.data) {
          return;
        }
        return {
          id: address.data.id,
          street: address.data.vejnavn,
          streetNumber: address.data.husnr,
          floor: address.data.etage,
          door: address.data.dør,
          zipCode: address.data.postnr,
          city: address.data.postnrnavn,
          oneLineAddress: address.tekst
        };
      },

      save(){
        const admin = Object.assign({}, this.admin)
        console.log(admin);

        Store.dispatch('addAdmin',admin).then(()=>{
          if(this.admin.id !== null){
            this.club.admin_id = this.admin.id

            const club = object.assign({}, this.club)
            console.log(club);

            Store.dispatch('addClub',club)
          }
        })
      },
      onPickLogo() {
        this.$refs.logoInput.click();
      },
      OnLogoPicked(event) {
        const files = event.target.files;
        let fileName = files[0].name;
        if (fileName.lastIndexOf(".") <= 0) {
          return alert("Please add a valid file! ");
        }
        const fileReader = new FileReader();
        fileReader.addEventListener("load", () => {
          this.logoURL = fileReader.result;
        });
        fileReader.readAsDataURL(files[0]);
        this.club.club_logo = files[0];
        console.log(this.logo);

      },
      onPickCover() {
        this.$refs.CoverInput.click();
      },
      OnCoverPicked(event) {
        const files = event.target.files;
        let fileName = files[0].name;
        if (fileName.lastIndexOf(".") <= 0) {
          return alert("Please add a valid file! ");
        }
        const fileReader = new FileReader();
        fileReader.addEventListener("load", () => {
          this.coverPhotoURL = fileReader.result;
        });
        fileReader.readAsDataURL(files[0]);
        this.coverPhoto = files[0];
        console.log(this.coverPhoto);
      },
      onPickImg(){
        this.$refs.ImgInput.click();

      },
      onPickVideo(){
        this.$refs.VideoInput.click();

      },
      onImgPicked(){
        const files = event.target.files;
        let fileName = files[0].name;
        if (fileName.lastIndexOf(".") <= 0) {
          return alert("Please add a valid file! ");
        }
        const fileReader = new FileReader();
        fileReader.addEventListener("load", () => {
          this.attachment.photosURL.push(fileReader.result);
          console.log( this.attachment.photosURL);

        });
        fileReader.readAsDataURL(files[0]);
        this.attachment.photos.push(files[0]);
      },
      onVideoPicked(){
        const files = event.target.files;
        let fileName = files[0].name;
        if (fileName.lastIndexOf(".") <= 0) {
          return alert("Please add a valid file! ");
        }
        const fileReader = new FileReader();
        fileReader.addEventListener("load", () => {
          this.attachment.videosURL.push(fileReader.result);
        });
        fileReader.readAsDataURL(files[0]);
        this.attachment.videos.push(files[0]);
      },

    },
    components: {
      DateDropdown,
      VueDawa
    }
  };
</script>

<style>
  .theme--light.v-stepper {
    overflow: scroll;
    height: 90vh;
    /*left: 100px;*/
    /*right: 100px;*/
    overflow: -moz-scrollbars-none;
    /*position: fixed;*/
  }
  .v-stepper::-webkit-scrollbar {
    display: none;
  }
  ::-webkit-scrollbar {
    display: none;
  }

  .theme--light.v-stepper .v-stepper__step__step, .theme--light.v-stepper .v-stepper__step__step .v-icon {
    color: #fff;
    padding: 18px;
    font-size: 13px ;
  }
  .pointer {cursor: pointer;}

  .cell {cursor: cell;}
  .list-dbg{
    background: white;
    padding: 10px;
    height: 156px;
    border-radius: 12px;
  }
  .time-ssrl{
    padding: 0px 5px 0px 5px;
  }
  ul ::-webkit-scrollbar {
    display: none;
  }
  .btn-customer{
    margin: 6px 0px 6px 0px !important;
    height: 45px;
    width: 100%;
  }
  .text-white{
    color: #ffffff!important;
  }
  li {
    scroll-snap-stop: always;
  }
  .containerr {
    display: flex;
    padding: 0px !important;
    overflow: auto;
    outline: 1px dashed lightgray;
    flex: none;
  }

  .date-dropdown-select[data-v-67d74744] {
    border: 1px solid #0051a0 !important;
    padding: 8px 25px!important;
  }
  .containerr.x {
    width: 100%;
    height: 128px;
    flex-flow: row nowrap;
  }
  .containerr.y {
    height: 100px;
    flex-flow: column nowrap;
  }
  .y.proximity-scroll-snapping {
    scroll-snap-type: y proximity;
  }
  .containerr > div {
    text-align: center;
    scroll-snap-align: center;
    flex: none;
  }

  .y.containerr > div {
    line-height: 100px;
    font-size: 30px;
    width: 100%;
    height: 100px;
    color: #fff;
  }
  .containerr > div:nth-child(even) {
    background-color: #0051a0;
    margin-top: 2px;
  }
  .containerr > div:nth-child(odd) {
    margin-top: 2px;
    background-color: #0051a0 !important;
  }
  .list-bg{
    background: #e6e6e6;
    padding: 10px;
    border-radius: 12px;
  }
  .v-tabs__item{
    padding: 3px 3px !important;
  }
  .time-srl{
    height: 74px;
    z-index: 1;
    font-size: 17px;
    list-style-type: none;
    padding: 25px 5px 25px 5px;
    color: #095697 !important;
    overflow: scroll;
  }
  ul ::-webkit-scrollbar {
    display: none;}
  .active{
    vertical-align: middle;
    /*font-size: 15px;*/
    /*font-weight: bold;*/
    align-items: center;
    /*text-align: center;*/
  }
  .v-progress-circular{
    margin: 1rem;
  }
  .card-pop{
    z-index: -4;
    margin-top: -12%;
  }
  .v-dialog{
    box-shadow: none!important;
  }
  .btn-customer{
    margin: 6px 0px 6px 0px !important;
    height: 45px;
    width: 100%;
  }
  .text-white{
    color: #ffffff!important;
  }
  .ccc{
    height: 35px!important;
    width: 94%!important;
    z-index: 0!important;
    border-bottom: 1px solid!important;
    border-top: 1px solid!important;
    left: 10px!important;
    top: 120px!important;
    position: absolute!important;
  }
  .theme--light.v-tabs__bar {
    background-color: transparent!important;
  }


</style>



// WEBPACK FOOTER //
// src/components/test/testSignup.vue